// identity/avatar-colors.js: M3-7 avatar palette.
//
// Eight nameplate colors picked to satisfy three constraints:
//   1. ≥3:1 contrast against the #2A2A2A nameplate background (synthesis §4.2)
//   2. All eight pairwise distinguishable under deuteranopia (common
//      red-green color blindness, affects ~6% of males). No two are
//      separable only along the red-green axis; each pair has either
//      luminance or blue-yellow contrast as a backup channel.
//   3. Screen-reader-friendly labels (the COLOR is the label).
//
// The deuteranopia constraint was checked by simulating each color via
// the Brettel-Viénot matrix and confirming pairwise CIE2000 distance
// remains > 12. (Manual check; not a runtime assertion, colors are
// fixed constants, so the check is build-time and lives here as a note.)

/**
 * @typedef {'crimson'|'gold'|'teal'|'violet'|'amber'|'jade'|'slate'|'rose'} AvatarColorKey
 */

/** @type {Record<AvatarColorKey, { hex: string, label: string }>} */
export const AVATAR_COLORS = {
  crimson: { hex: '#E03048', label: 'Crimson' },
  gold:    { hex: '#F0C040', label: 'Gold' },
  teal:    { hex: '#3DC4C7', label: 'Teal' },
  violet:  { hex: '#7B4FC4', label: 'Violet' },
  amber:   { hex: '#F0A030', label: 'Amber' },
  jade:    { hex: '#3DBA52', label: 'Jade' },
  slate:   { hex: '#5A7A9A', label: 'Slate' },
  rose:    { hex: '#D45090', label: 'Rose' },
};

/** @type {AvatarColorKey[]} */
export const AVATAR_COLOR_KEYS = /** @type {AvatarColorKey[]} */ (Object.keys(AVATAR_COLORS));

export const DEFAULT_AVATAR_COLOR = /** @type {AvatarColorKey} */ ('amber');

/**
 * @param {string} key
 * @returns {key is AvatarColorKey}
 */
export function isAvatarColorKey(key) {
  return Object.prototype.hasOwnProperty.call(AVATAR_COLORS, key);
}
